import React from 'react';

import './GetStarted.css';

export const GetStarted = () => {
  return (
    <div className="get-started-container">
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          //   alignItems: 'center',
          padding: '0% 2%',
          margin: '4%',
        }}
      >
        <img
          src="https://www.ridenowauctions.com/wp-content/uploads/2022/11/aboutride.png"
          width={'400px'}
          height={'400px'}
          style={{ backgroundColor: 'gray' }}
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          //   justifyContent: 'center',
          alignItems: 'center',
          padding: '0% 2%',
          margin: '4%',
        }}
      >
        <h3 style={{ fontSize: '32px', marginTop: 0 }}>
          Ready to Get Started?
        </h3>

        <p style={{ textAlign: 'center', lineHeight: '1.2rem' }}>
          <span style={{ fontSize: '16px' }}>
            Participating in RideNow Auctions is easy! Sign-up and create your
            account to get started.
          </span>
          <br />
          <br />
          Let us know if you want to go ahead and get pre-approved for
          financing, or if you are wanting to trade in another vehicle for
          credit toward any auction you win. Our concierge team is standing by
          and will reach out to you on account completion to handle and explain
          everything in detail. After your fully refundable $250 deposit has
          been completed, and a credit card added to your account, then you are
          ready to start bidding! At any point, if you would like to see the
          vehicles in person, you can just pop on over to our RideNow Orlando
          location and take a look. After you have won a lot, your concierge
          will be contacting you to complete the transaction and tie up any
          loose ends. If you are looking to have your vehicle shipped, our team
          member will connect you with our shipping partner and collect a
          shipping fee. All vehicles are backed by our 3-day money-back
          guarantee (less shipping costs if applicable) and our 90-day
          powertrain warranty, so you can rest assured you are getting the best
          deal possible.
        </p>

        <button
          style={{ width: '200px' }}
          onClick={() =>
            window.open('https://ridenowauctions.com/signup', '_blank')
          }
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};
